import React, { SetStateAction, useEffect, useRef } from "react";
import { X } from "lucide-react";

export const DisclaimerModal = ({
  showDisclaimerModal,
  setShowDisclaimerModal,
  handleMouseLeave,
  handleMouseEnter,
}: {
  showDisclaimerModal: boolean;
  setShowDisclaimerModal: React.Dispatch<SetStateAction<boolean>>;
  handleMouseEnter: () => void;
  handleMouseLeave: () => void;
}) => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const body = document.body;
    if (showDisclaimerModal) {
      body.classList.add("body-no-scroll");
    } else {
      body.classList.remove("body-no-scroll");
    }

    return () => {
      body.classList.remove("body-no-scroll");
    };
  }, [showDisclaimerModal]);
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-40 backdrop-blur-sm transition-all">
      <div
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className="bg-white shadow-2xl rounded-2xl w-full max-w-2xl relative p-6 sm:p-8"
      >
        <button
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-800 transition-colors"
          onClick={() => setShowDisclaimerModal(false)}
        >
          <X size={24} />
        </button>
        <div className="space-y-4 text-gray-700">
          <h1 className="text-base lg:text-2xl font-bold text-center text-brand-orange">
            ⚠️ Disclaimer
          </h1>
          <p className="text-xs lg:text-base leading-relaxed text-center">
            Auction Bazaar employees will <strong>never</strong> request or
            accept cash payments or transfers to personal accounts. All Earnest
            Money Deposit (EMD) payments must be made directly to sellers either
            through <strong>Demand Draft (DD)</strong>,{" "}
            <strong>NEFT/RTGS</strong>, or <strong>WALLET Transfer</strong> as
            specified in the auction notices. Please adhere to the published
            terms and conditions of the respective auction notice.
          </p>
          <p className="text-xs lg:text-base leading-relaxed text-center">
            Please verify all payment details before making any transactions. If
            you receive any suspicious payment requests,{" "}
            <strong>do not proceed</strong> and report them immediately to our
            support team at{" "}
            <a
              href="mailto:support@auctionbazaar.com"
              className="text-blue-600 hover:underline"
            >
              support@auctionbazaar.com
            </a>
            .
          </p>
          <p className="text-xs lg:text-base leading-relaxed text-center">
            Auction Bazaar is not liable for transactions that do not adhere to
            the prescribed payment methods of the auction notice. We will not be
            responsible for any loss or damages incurred from transactions that
            do not comply with our listed payment procedures.
          </p>
        </div>
      </div>
    </div>
  );
};
